/**
 * @generated SignedSource<<7e2d954f9dbd432a0dc2fffd20e06835>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgUserEditAccessSelect_workspaces$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly subWorkspaceCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelectorContent_workspaces">;
  readonly " $fragmentType": "OrgUserEditAccessSelect_workspaces";
}>;
export type OrgUserEditAccessSelect_workspaces$key = ReadonlyArray<{
  readonly " $data"?: OrgUserEditAccessSelect_workspaces$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgUserEditAccessSelect_workspaces">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "OrgUserEditAccessSelect_workspaces",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subWorkspaceCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceSelectorContent_workspaces"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "346c87567512153303caa0bb7506117a";

export default node;
